// extracted by mini-css-extract-plugin
export var img = "style-module--img--wxVXf";
export var img__absolute = "style-module--img__absolute--lvZvB";